import type { AiBusinessCenterModule } from '../types'

export const scrmModule: AiBusinessCenterModule = {
  key: 'scrm',
  label: 'SCRM 私域运营',
  desc: '客户管理 / 社群运营 / 渠道活码 / 智能触达',
  path: '/scrm',
  homePath: '/scrm/dashboard',
  icon: 'ep:connection',
  color: '#14b8a6',
  aliases: ['SCRM系统', 'SCRM 系统']
}
